/* eslint-disable */
import React, { useState } from 'react';
import { authAPI } from '../../services/api';

// LEGAL-002: Blocking gate shown to any user whose accepted legal version
// doesn't match the current one — covers existing users after a document
// update. New self-service registrations accept during signup instead (see
// Login.js); admin-created accounts accept during their forced password
// setup (see MustChangePassword.js).
export default function AcceptLegalTerms({ username }) {
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!checked) return;
    setLoading(true);
    setError('');
    try {
      await authAPI.acceptLegal();
      // Reload so the app fetches fresh /me data and the gate clears
      window.location.reload();
    } catch (err) {
      setError(err?.error || 'Failed to record your acceptance. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', maxWidth: '460px' }}>
        <div className="login-card" style={{ width: '100%' }}>
          <div className="login-logo">
            <img src="/casavello-stacked.png" alt="casavello" style={{ width: '140px', height: 'auto', objectFit: 'contain', marginBottom: '0.5rem' }} />
          </div>

          <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>📋</div>
            <h2 style={{ margin: '0 0 0.25rem', fontSize: '1.25rem', fontWeight: 700 }}>Our Terms Have Been Updated</h2>
            <p style={{ margin: 0, fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
              {username ? <>Hi <strong>{username}</strong> — </> : null}
              please review and accept our updated legal documents to continue using casavello.
            </p>
          </div>

          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div style={{ background: '#f8fafc', border: '1px solid var(--border)', borderRadius: '0.5rem', padding: '1rem', marginBottom: '1.25rem', fontSize: '0.85rem' }}>
              <p style={{ margin: '0 0 0.6rem', color: 'var(--text-secondary)' }}>Please read the following before continuing:</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                <a href="/terms" onClick={e => { e.preventDefault(); window.open('/terms', '_blank', 'noopener,noreferrer'); }} style={{ color: 'var(--brand-green)', fontWeight: 600, cursor: 'pointer' }}>📄 Terms of Service ↗</a>
                <a href="/eula" onClick={e => { e.preventDefault(); window.open('/eula', '_blank', 'noopener,noreferrer'); }} style={{ color: 'var(--brand-green)', fontWeight: 600, cursor: 'pointer' }}>📄 End User Licence Agreement (EULA) ↗</a>
                <a href="/privacy" onClick={e => { e.preventDefault(); window.open('/privacy', '_blank', 'noopener,noreferrer'); }} style={{ color: 'var(--brand-green)', fontWeight: 600, cursor: 'pointer' }}>📄 Privacy Policy ↗</a>
              </div>
            </div>

            <label style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem', marginBottom: '1.25rem', cursor: 'pointer', fontSize: '0.85rem', lineHeight: 1.5 }}>
              <input
                type="checkbox"
                checked={checked}
                onChange={e => setChecked(e.target.checked)}
                style={{ marginTop: '0.2rem', flexShrink: 0 }}
              />
              <span>I have read and agree to the Terms of Service, EULA and Privacy Policy.</span>
            </label>

            <button
              type="submit"
              className="btn btn-success"
              style={{ width: '100%', padding: '0.875rem', fontSize: '1rem' }}
              disabled={loading || !checked}
            >
              {loading ? 'Saving...' : '✅ Accept & Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
